import moment from 'moment';

// ISODate :: String
// @link: https://en.wikipedia.org/wiki/ISO_8601

// YYYY-MM-DDThh:mm:ss.sssZ :: "2017-08-16T19:49:50.940Z"
// YYYY-MM-DD               :: "2017-08-16"

// subtractMonths :: ISODate, Number  -> ISODate
const subtractMonths = (date, months) =>
  moment(date)
    .subtract(months, 'months')
    .toISOString();

export default subtractMonths;
